$(document).on("click", "#nextButton", function (event) {
  $(".number-2").addClass("slected");
  $("#step2").show().attr("data-aos", "fade-right");
  $("#step1").removeAttr("data-aos");
  $("#step1").hide();
  $(".product").hide();
  $(".progress1").css("background", "#128ea9");
});

$("#prevButton2").click(function (event) {
  $("#step1").show().attr("data-aos", "fade-right");
  $(".number-2").removeClass("slected");
  $("#step2").hide();
  $(".product").hide();
  $(".progress1").css("background", "#e6e4e4");
  $("#step2").removeAttr("data-aos");
});
$("#nextButton2").click(function (event) {
  $(".techn-section-door-frame-measurement")
    .show()
    .attr("data-aos", "fade-right");
  $(".progress1").css("background", "#128ea9");
  $(".techn-section-door-frame-measurement").show();
  $(".number-3").addClass("slected");
  $(".product").css("display", "flex");
  $(".product").show().attr("data-aos", "fade-right");
  document.querySelectorAll(".product").forEach(function (element) {
    element.style.display = "flex";
    $("#prevButton3").show();
    $(".steps1").show();
  });
  $(".product").show();
  $(".techn-section-door-frame-measurement").hide();
  $(".product").show();
  $("#step1").hide();
  $("#step2").hide();
});
$("#prevButton3").click(function (event) {
  $("#step2").show().attr("data-aos", "fade-right");
  $(".number-2").addClass("slected");
  $(".techn-section-door-frame-measurement").show();
  $("#step2").show();
  $("#step1").hide();
  $(".product").hide();
  $(".progress2").css("background", "#e6e4e4");
  $(".progress1").css("background", "#128ea9");
});

$("#card1btnnext").click(function (event) {
  $("#card2").show();
  $("#card1").hide();
  $("#card3").hide();
  $("#card4").hide();
});
$("#card2btnprev").click(function (event) {
  $("#card2").hide();
  $("#card1").show();
});
$("#card2btnnext").click(function (event) {
  $("#card2").hide();
  $("#card1").hide();
  $("#card3").show();
  $("#card4").hide();
});

$("#card3btnnext").click(function (event) {
  $("#card2").hide();
  $("#card1").hide();
  $("#card3").hide();
  $("#card4").show();
});
$("#card4btnprev").click(function (event) {
  $("#card1").hide();
  $("#card2").hide();
  $("#card3").show();
  $("#card4").hide();
});
$("#card3btnprev").click(function (event) {
  $("#card1").hide();
  $("#card2").show();
  $("#card3").hide();
  $("#card4").hide();
});
$("#card4btnnext").click(function (event) {
  $("#card1").hide();
  $("#card2").hide();
  $("#card3").hide();
  $("#card4").hide();
  $("#recommendedSizeContainer").show();
});
$("#finelSizeNext").click(function (event) {
  $("#card1").hide();
  $("#card2").hide();
  $("#card3").hide();
  $("#card4").hide();
  $("#recommendedSizeContainer").hide();
  $(".measurements-color").show();
});
$("#finelSizeprev").click(function (event) {
  $("#card1").hide();
  $("#card2").hide();
  $("#card3").hide();
  $("#card4").show();
  $("#recommendedSizeContainer").hide();
});
$("#productNext").click(function (event) {
  $("#card1").hide();
  $("#card2").hide();
  $("#card3").hide();
  $("#card4").hide();
  $("#recommendedSizeContainer").hide();
  $(".measurements-color").hide();
  $(".product").show();
  $("#prevButton3").show();
});
$("#productprev").click(function (event) {
  $("#card1").hide();
  $("#card2").hide();
  $("#card3").hide();
  $("#card4").hide();
  $("#recommendedSizeContainer").show();
  $(".product").hide();
  $(".measurements-color").hide();
});
$("#innerHeight").on("keyup", function (event) {
  if (event.key === "Enter") {
    $("#card1btnnext").click();
  }
});
$("#outerHeight").on("keyup", function (event) {
  if (event.key === "Enter") {
    $("#card2btnnext").click();
  }
});
$("#innerWidth").on("keyup", function (event) {
  if (event.key === "Enter") {
    $("#card3btnnext").click();
  }
});
$("#outerWidth").on("keyup", function (event) {
  if (event.key === "Enter") {
    $("#card4btnnext").click();
  }
});
